import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SpotifyOutlinedSvg from "@ant-design/icons-svg/es/asn/SpotifyOutlined";
import AntdIcon from "../components/AntdIcon";
var SpotifyOutlined = function SpotifyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SpotifyOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SpotifyOutlined.displayName = 'SpotifyOutlined';
}
export default /*#__PURE__*/React.forwardRef(SpotifyOutlined);